import { subDays, today } from '../../../utils/date';

const publicRootNode = document.getElementById('public-ai-dashboard-root');
const rootNode = document.getElementById('finance-page-root');

const initMaxDateTo = publicRootNode?.dataset?.maxDateTo || null;
const fallbackMaxDateTo = rootNode?.dataset?.maxDateTo || null;
export const initMaxDate = initMaxDateTo || fallbackMaxDateTo || subDays(today(), 1);

export const zooming = {
  type: 'x',
  resetButton: {
    theme: {
      fill: '#fff',
      stroke: '#E1E5EB',
      r: 4,
      color: '#363D54',
      states: {
        hover: {
          fill: '#EDF0F5',
        },
      },
    },
  },
};

export const basePartialFilters = {
  period_to_date: initMaxDate,
  granularity: 'monthly',
};

export const advancedPartialFilters = {
  period_to_date: initMaxDate,
  granularity: 'monthly',
};
